import React, { useState, useEffect, memo } from 'react';
import '../css/Filters.css';
import { Link, useHistory, useLocation } from 'react-router-dom';
import {updateHistory, checkForFilters, compareFilters} from '../utils/data';
import {useFilterContext, useFilterDispatch, emptyFilters, getFiltersFromUrl, adminFilterOps} from '../contexts/FilterContextProvider';
import {useProjectData} from '../contexts/ProjectDataContextProvider';
import SkipLink from './SkipLink';
import AutocompleteSearch from './AutocompleteSearch';
import { Navbar, Collapse, Nav } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMinus, faPlus, faHome, faList, faBars, faQuestionCircle } from '@fortawesome/free-solid-svg-icons';
import { faCheckSquare, faSquare } from '@fortawesome/free-regular-svg-icons';

const locData = {
    cities: [],
    counties: [], 
    regions: [],
    acts: [], 
    mpos: [],
    congDistricts: [],
    houseDistricts: [],
    senateDistricts: []
}
var _filters;

function Filters() {
    const history = useHistory();
    const location = useLocation();
    const filters = useFilterContext();
    _filters = filters;
    const filterDispatch = useFilterDispatch();
    var hasFilters = checkForFilters(filters);
    const {projectData} = useProjectData();
    
    const [filtersOpen, setFiltersOpen] = useState(false);
    function toggleFilters() {
        setFiltersOpen(!filtersOpen);
        setPhasesOpen(filtersOpen);
        setTypesOpen(filtersOpen);
        setYearsOpen(filtersOpen);
        setAdminsOpen(filtersOpen);
        setPerformanceOpen(filtersOpen);
        setLocationsOpen(filtersOpen);
        setMappedOpen(filtersOpen);
    }

    const [phasesOpen, setPhasesOpen] = useState(false);
    function togglePhases() {
        setPhasesOpen(!phasesOpen);
    }
    const [typesOpen, setTypesOpen] = useState(false);
    function toggleTypes() {
        setTypesOpen(!typesOpen);
    }
    const [yearsOpen, setYearsOpen] = useState(false);
    function toggleYears() {
        setYearsOpen(!yearsOpen);
    }
    const [adminsOpen, setAdminsOpen] = useState(false);
    function toggleAdmins() {
        setAdminsOpen(!adminsOpen);
    }
    const [performanceOpen, setPerformanceOpen] = useState(false);
    function togglePerformance() {
        setPerformanceOpen(!performanceOpen);
    }
    const [locationsOpen, setLocationsOpen] = useState(false);
    function toggleLocations() {
        setLocationsOpen(!locationsOpen);
    }
    const [mappedOpen, setMappedOpen] = useState(false);
    function toggleMapped() {
        setMappedOpen(!mappedOpen);
    }
    
    useEffect(() => {
        import("../config/filters").then(filters => {
            locData.cities = filters.cityList;
            locData.counties = filters.countyList;
            locData.regions = filters.regionList;
            locData.acts = filters.actList;
            locData.mpos = filters.mpoList;
            locData.congDistricts = filters.congDistrictList;
            locData.houseDistricts = filters.houseDistrictList;
            locData.senateDistricts = filters.senateDistrictList;
        });
    }, []);

    useEffect(() => {
        let urlFilters = getFiltersFromUrl(location.pathname, location.search);
        let filterCompareResults = compareFilters(urlFilters, _filters);
        
        if (filterCompareResults.filtersDiffer) {
            filterDispatch({
                type: 'urlFilterUpdate',
                pagePayload: urlFilters.page,
                searchPayload: urlFilters.search,
                locationPayload: urlFilters.location,
                phasePayload: urlFilters.phase,
                performancePayload: urlFilters.performance,
                yearPayload: urlFilters.year,
                typePayload: urlFilters.type,
                adminPayload: urlFilters.admin,
                mapPayload: urlFilters.map,
                mapPointPayload: urlFilters.mapPoint,
                updatedFilter: filterCompareResults.updatedFilter,
                selectedForListPayload: filterCompareResults.updatedFilter === "removedMapPoint" ? [] : null,
                selectedForSnapshotPayload: filterCompareResults.updatedFilter === "snapshot" ? urlFilters.selectedForSnapshot : null,
                mappedPayload: urlFilters.mapped
            });
        }
    }, [location, filterDispatch]);

    const filterClick = (e, clickedFilter, filterValue) => {
        const targetVal = e.target.value;
        e.preventDefault();
        let newFilters = JSON.parse(JSON.stringify(filters));
        
        switch(clickedFilter) {
            case "projects":
                newFilters = JSON.parse(JSON.stringify(emptyFilters));
                newFilters.page = "projects";
                filterDispatch({
                    type: 'page',
                    payload: "projects"
                });
                updateHistory(history, newFilters);
                break;
            case "location": 
                let locationInfo = targetVal.split(':');
                newFilters.location[locationInfo[0]].selectedLocation = locationInfo[1] !== "default" ? locationInfo[1] : "";
                newFilters.page = checkForFilters(newFilters) ? "" : "projects";
                newFilters.mapPoint = locationInfo[1] !== "default" ? "" : newFilters.mapPoint;
                filterDispatch({
                    type: 'location',
                    subtype: locationInfo[0],
                    payload: newFilters.location[locationInfo[0]].selectedLocation,
                    pagePayload: newFilters.page
                });
                updateHistory(history, newFilters);
                break;
            case "search":
                newFilters.search = filterValue;
                newFilters.page = checkForFilters(newFilters) ? "" : "projects";
                filterDispatch({
                    type: 'search',
                    payload: filterValue
                });
                updateHistory(history, newFilters);
                break;
            case "phase":
                if (newFilters.phase.includes(filterValue)) {
                    newFilters.phase.splice(newFilters.phase.indexOf(filterValue), 1);
                }
                else {
                    newFilters.phase.push(filterValue);
                }
                newFilters.page = checkForFilters(newFilters) ? "" : "projects";
                filterDispatch({
                    type: 'phase',
                    payload: filterValue,
                    pagePayload: newFilters.page
                });
                updateHistory(history, newFilters);
                break;
            case "performance":
                if (newFilters.performance.includes(filterValue)) {
                    newFilters.performance.splice(newFilters.performance.indexOf(filterValue), 1);
                }
                else {
                    newFilters.performance.push(filterValue);
                }
                newFilters.page = checkForFilters(newFilters) ? "" : "projects";
                filterDispatch({
                    type: 'performance',
                    payload: filterValue,
                    pagePayload: newFilters.page
                });
                updateHistory(history, newFilters);
                break;
            case "year":
                if (newFilters.year.includes(filterValue)) {
                    newFilters.year.splice(newFilters.year.indexOf(filterValue), 1);
                }
                else {
                    newFilters.year.push(filterValue);
                }
                newFilters.page = checkForFilters(newFilters) ? "" : "projects";
                filterDispatch({
                    type: 'year',
                    payload: filterValue,
                    pagePayload: newFilters.page
                });
                updateHistory(history, newFilters);
                break;
            case "type":
                if (newFilters.type.includes(filterValue)) {
                    newFilters.type.splice(newFilters.type.indexOf(filterValue), 1);
                }
                else {
                    newFilters.type.push(filterValue);
                }
                newFilters.page = checkForFilters(newFilters) ? "" : "projects";
                filterDispatch({
                    type: 'type',
                    payload: filterValue,
                    pagePayload: newFilters.page
                });
                updateHistory(history, newFilters);
                break;
            case "admin":
                if (newFilters.admin.includes(filterValue)) {
                    newFilters.admin.splice(newFilters.admin.indexOf(filterValue), 1);
                }
                else {
                    newFilters.admin.push(filterValue);
                }
                newFilters.page = checkForFilters(newFilters) ? "" : "projects";
                filterDispatch({
                    type: 'admin',
                    payload: filterValue,
                    pagePayload: newFilters.page
                });
                updateHistory(history, newFilters);
                break;
            case "mapped":
                if (newFilters.mapped.includes(filterValue)) {
                    newFilters.mapped.splice(newFilters.mapped.indexOf(filterValue), 1);
                }
                else {
                    newFilters.mapped.push(filterValue);
                }
                newFilters.page = checkForFilters(newFilters) ? "" : "projects";
                filterDispatch({
                    type: 'mapped',
                    payload: filterValue,
                    pagePayload: newFilters.page
                });
                updateHistory(history, newFilters);
                break;
            default:
                newFilters = JSON.parse(JSON.stringify(emptyFilters));
                newFilters.page = "home";
                filterDispatch({
                    type: 'page',
                    payload: "home"
                });
                updateHistory(history, newFilters);
        }

        if (filtersOpen) {
            setFiltersOpen(!filtersOpen);
        }
    };

    return (
        <div id="filterContainer" className={filters.map.indexOf('full') !== -1 ? "hide" : "col-lg-2"}>
            <Navbar id="side-nav" color="faded" light expand="lg" aria-label="Main">
                <button type="button" className="navbar-toggler" onClick={toggleFilters}>
                    <span className="navbar-toggler-icon"><FontAwesomeIcon icon={faBars} aria-label="Bars" /></span>
                </button>
                <Collapse isOpen={filtersOpen} navbar id="filterContainer-collapse">
                    <Nav vertical>
                        <Link to="/" className={"filter" + (filters.page !== "projects" && filters.page !== "" ? " filter-selected" : "")} onClick={(e) => filterClick(e, "")}><FontAwesomeIcon icon={faHome} aria-label="Home" className="filter-icon" />Home</Link>
                        <Link to="/projects" className={"filter" + (filters.page === "projects" && !hasFilters ? " filter-selected" : "")} onClick={(e) => filterClick(e, "projects")}><FontAwesomeIcon icon={faList} aria-label="List" className="filter-icon" />All Projects</Link>

                        <AutocompleteSearch filtersOpen={filtersOpen} setFiltersOpen={setFiltersOpen} />
                        <SkipLink />

                        
                        <div className="filter-collapse-section">
                            <button className="btn" onClick={togglePhases}><h2 className="filter-header">Phase <FontAwesomeIcon icon={phasesOpen ? faMinus : faPlus} className="toggle-icon" aria-label="Collapse" /></h2></button>
                            <Collapse isOpen={phasesOpen}>
                                <ul className="fa-ul">
                                    <li key="Planning"><Link to={"/projects?phase=Planning"} className={"filter" + (filters.phase.includes("Planning") ? " filter-selected" : "")} onClick={(e) => filterClick(e, "phase", "Planning")}><span className="fa-li"><FontAwesomeIcon icon={filters.phase.includes("Planning") ? faCheckSquare : faSquare} aria-label="Checkmark" /></span>Planning</Link></li>
                                    <li key="Design"><Link to={"/projects?phase=Design"} className={"filter" + (filters.phase.includes("Design") ? " filter-selected" : "")} onClick={(e) => filterClick(e, "phase", "Design")}><span className="fa-li"><FontAwesomeIcon icon={filters.phase.includes("Design") ? faCheckSquare : faSquare} aria-label="Checkmark" /></span>Design</Link></li>
                                    <li key="Construction"><Link to={"/projects?phase=Construction"} className={"filter" + (filters.phase.includes("Construction") ? " filter-selected" : "")} onClick={(e) => filterClick(e, "phase", "Construction")}><span className="fa-li"><FontAwesomeIcon icon={filters.phase.includes("Construction") ? faCheckSquare : faSquare} aria-label="Checkmark" /></span>Construction</Link></li>
                                    <li key="Completed"><Link to={"/projects?phase=Completed"} className={"filter" + (filters.phase.includes("Completed") ? " filter-selected" : "")} onClick={(e) => filterClick(e, "phase", "Completed")}><span className="fa-li"><FontAwesomeIcon icon={filters.phase.includes("Completed") ? faCheckSquare : faSquare} aria-label="Checkmark" /></span>Completed</Link></li>
                                    <li key="Other"><Link to={"/projects?phase=Other"} className={"filter" + (filters.phase.includes("Other") ? " filter-selected" : "")} onClick={(e) => filterClick(e, "phase", "Other")}><span className="fa-li"><FontAwesomeIcon icon={filters.phase.includes("Other") ? faCheckSquare : faSquare} aria-label="Checkmark" /></span>Other</Link></li>
                                </ul>
                            </Collapse>
                        </div>

                        <div className="filter-collapse-section">
                            <button className="btn" onClick={toggleYears}><h2 className="filter-header">Year <FontAwesomeIcon icon={yearsOpen ? faMinus : faPlus} className="toggle-icon" aria-label="Collapse" /></h2></button>
                            <Collapse isOpen={yearsOpen}>
                                <ul className="fa-ul">
                                {projectData.yearFilterOps && projectData.yearFilterOps.map(yearFilterOp => {
                                    return(
                                        <li key={yearFilterOp}><Link to={"/projects?year=" + yearFilterOp} className={"filter" + (filters.year.includes(yearFilterOp) ? " filter-selected" : "")} onClick={(e) => filterClick(e, "year", yearFilterOp)}><span className="fa-li"><FontAwesomeIcon icon={filters.year.includes(yearFilterOp) ? faCheckSquare : faSquare} aria-label="Checkmark" /></span>{yearFilterOp}</Link></li>
                                    );
                                })}
                                </ul>
                            </Collapse>
                        </div>

                        <div className="filter-collapse-section">
                            <button className="btn" onClick={toggleTypes}><h2 className="filter-header">Type <FontAwesomeIcon icon={typesOpen ? faMinus : faPlus} className="toggle-icon" aria-label="Collapse" /></h2></button>
                            <Collapse isOpen={typesOpen}>
                                <ul className="fa-ul">
                                    {
                                        projectData.typeFilterOps ? projectData.typeFilterOps.map((type) => 
                                        <li key={type}><Link to={"/projects?type=" + type} className={"filter" + (filters.type.includes(type) ? " filter-selected" : "")} onClick={(e) => filterClick(e, "type", type)}><span className="fa-li"><FontAwesomeIcon icon={filters.type.includes(type) ? faCheckSquare : faSquare} aria-label="Checkmark" /></span>{type === "Bicycle/Pedestrian" ? "Bicycle / Pedestrian" : type}</Link></li>)
                                        : ""
                                    }
                                </ul>
                            </Collapse>
                        </div>

                        <div className="filter-collapse-section">
                            <button className="btn" onClick={toggleAdmins}><h2 className="filter-header">Administrator <FontAwesomeIcon icon={adminsOpen ? faMinus : faPlus} className="toggle-icon" aria-label="Collapse" /></h2></button>
                            <Collapse isOpen={adminsOpen}>
                                <ul className="fa-ul">
                                {adminFilterOps && adminFilterOps.map(adminFilterOp => {
                                    return(
                                        <li key={adminFilterOp.val}><Link to={"/projects?admin=" + adminFilterOp.val} className={"filter" + (filters.admin.includes(adminFilterOp.val) ? " filter-selected" : "")} onClick={(e) => filterClick(e, "admin", adminFilterOp.val)}><span className="fa-li"><FontAwesomeIcon icon={filters.admin.includes(adminFilterOp.val) ? faCheckSquare : faSquare} aria-label="Checkmark" /></span>{adminFilterOp.display}</Link></li>
                                    );
                                })}
                                </ul>
                            </Collapse>
                        </div>

                        <div className="filter-collapse-section">
                            <button className="btn" onClick={togglePerformance}><h2 className="filter-header">Performance <FontAwesomeIcon icon={performanceOpen ? faMinus : faPlus} className="toggle-icon" aria-label="Collapse" /></h2></button>
                            <Collapse isOpen={performanceOpen}>
                                <ul className="fa-ul">
                                    <li key="OnTime"><Link to={"/projects?performance=OnTime"} className={"filter" + (filters.performance.includes("OnTime") ? " filter-selected" : "")} onClick={(e) => filterClick(e, "performance", "OnTime")}><span className="fa-li"><FontAwesomeIcon icon={filters.performance.includes("OnTime") ? faCheckSquare : faSquare} aria-label="Checkmark" /></span>On Time</Link></li>
                                    <li key="Late"><Link to={"/projects?performance=Late"} className={"filter" + (filters.performance.includes("Late") ? " filter-selected" : "")} onClick={(e) => filterClick(e, "performance", "Late")}><span className="fa-li"><FontAwesomeIcon icon={filters.performance.includes("Late") ? faCheckSquare : faSquare} aria-label="Checkmark" /></span>Late</Link></li>
                                    <li key="OnBudget"><Link to={"/projects?performance=OnBudget"} className={"filter" + (filters.performance.includes("OnBudget") ? " filter-selected" : "")} onClick={(e) => filterClick(e, "performance", "OnBudget")}><span className="fa-li"><FontAwesomeIcon icon={filters.performance.includes("OnBudget") ? faCheckSquare : faSquare} aria-label="Checkmark" /></span>On Budget</Link></li>
                                    <li key="OverBudget"><Link to={"/projects?performance=OverBudget"} className={"filter" + (filters.performance.includes("OverBudget") ? " filter-selected" : "")} onClick={(e) => filterClick(e, "performance", "OverBudget")}><span className="fa-li"><FontAwesomeIcon icon={filters.performance.includes("OverBudget") ? faCheckSquare : faSquare} aria-label="Checkmark" /></span>Over Budget</Link></li>
                                </ul>
                            </Collapse>
                        </div>

                        <div className="filter-collapse-section">
                            <button className="btn" onClick={toggleLocations}><h2 className="filter-header">Location <FontAwesomeIcon icon={locationsOpen ? faMinus : faPlus} className="toggle-icon" aria-label="Collapse" /></h2></button>
                                <Collapse isOpen={locationsOpen}>
                                    <select aria-label="Select city" className="form-control" onChange={(e) => filterClick(e, "location")} value={filters.location.city.name + ":" + filters.location.city.selectedLocation}>
                                        <option key="default" value={filters.location.city.name + ":default"}>City</option>
                                        {(locData) ? locData.cities.map((loc) => <option key={loc.value} value={loc.value}>{loc.display}</option>) : ""}
                                    </select>
                                    <select aria-label="Select county" className="form-control" onChange={(e) => filterClick(e, "location")} value={filters.location.county.name + ":" + filters.location.county.selectedLocation}>
                                        <option key="default" value={filters.location.county.name + ":default"}>County</option>
                                        {(locData) ? locData.counties.map((loc) => <option key={loc.value} value={loc.value}>{loc.display}</option>) : ""}
                                    </select>
                                    <select aria-label="Select ODOT region" className="form-control" onChange={(e) => filterClick(e, "location")} value={filters.location.region.name + ":" + filters.location.region.selectedLocation}>
                                        <option key="default" value={filters.location.region.name + ":default"}>ODOT Region</option>
                                        {(locData) ? locData.regions.map((loc) => <option key={loc.value} value={loc.value}>{loc.display}</option>) : ""}
                                    </select>
                                    <select aria-label="Select ACT" className="form-control" onChange={(e) => filterClick(e, "location")} value={filters.location.act.name + ":" + filters.location.act.selectedLocation}>
                                        <option key="default" value={filters.location.act.name + ":default"}>ACT</option>
                                        {(locData) ? locData.acts.map((loc) => <option key={loc.value} value={loc.value}>{loc.display}</option>) : ""}
                                    </select>
                                    <select aria-label="Select MPO" className="form-control" onChange={(e) => filterClick(e, "location")} value={filters.location.mpo.name + ":" + filters.location.mpo.selectedLocation}>
                                        <option key="default" value={filters.location.mpo.name + ":default"}>MPO</option>
                                        {(locData) ? locData.mpos.map((loc) => <option key={loc.value} value={loc.value}>{loc.display}</option>) : ""}
                                    </select>
                                    <select aria-label="Select congressional district" className="form-control" onChange={(e) => filterClick(e, "location")} value={filters.location.congDistrict.name + ":" + filters.location.congDistrict.selectedLocation}>
                                        <option key="default" value={filters.location.congDistrict.name + ":default"}>Congressional District</option>
                                        {(locData) ? locData.congDistricts.map((loc) => <option key={loc.value} value={loc.value}>{loc.display}</option>) : ""}
                                    </select>
                                    <select aria-label="Select house district" className="form-control" onChange={(e) => filterClick(e, "location")} value={filters.location.houseDistrict.name + ":" + filters.location.houseDistrict.selectedLocation}>
                                        <option key="default" value={filters.location.houseDistrict.name + ":default"}>House District</option>
                                        {(locData) ? locData.houseDistricts.map((loc) => <option key={loc.value} value={loc.value}>{loc.display}</option>) : ""}
                                    </select>
                                    <select aria-label="Select senate district" className="form-control" onChange={(e) => filterClick(e, "location")} value={filters.location.senateDistrict.name + ":" + filters.location.senateDistrict.selectedLocation}>
                                        <option key="default" value={filters.location.senateDistrict.name + ":default"}>Senate District</option>
                                        {(locData) ? locData.senateDistricts.map((loc) => <option key={loc.value} value={loc.value}>{loc.display}</option>) : ""}
                                    </select>
                                </Collapse>
                        </div>

                        <div className="filter-collapse-section">
                            <button className="btn" onClick={toggleMapped}><h2 className="filter-header">Mapped <FontAwesomeIcon icon={mappedOpen ? faMinus : faPlus} className="toggle-icon" aria-label="Collapse" /></h2></button>
                            <Collapse isOpen={mappedOpen}>
                                <ul className="fa-ul">
                                    <li key="mapped"><Link to={"/projects?mapped=TRUE"} className={"filter" + (filters.mapped.includes("TRUE") ? " filter-selected" : "")} onClick={(e) => filterClick(e, "mapped", "TRUE")}><span className="fa-li"><FontAwesomeIcon icon={filters.mapped.includes("TRUE") ? faCheckSquare : faSquare} aria-label="Checkmark" /></span>Mapped</Link></li>
                                    <li key="nonmapped"><Link to={"/projects?mapped=FALSE"} className={"filter" + (filters.mapped.includes("FALSE") ? " filter-selected" : "")} onClick={(e) => filterClick(e, "mapped", "FALSE")}><span className="fa-li"><FontAwesomeIcon icon={filters.mapped.includes("FALSE") ? faCheckSquare : faSquare} aria-label="Checkmark" /></span>Non-mapped</Link></li>
                                </ul>
                            </Collapse>
                        </div>
                        <SkipLink />

                        <a href="https://www.oregon.gov/ODOT/Projects/Pages/UsingTPT.aspx" rel="noreferrer" className="filter mt-2"><FontAwesomeIcon icon={faQuestionCircle} aria-label="Question" className="filter-icon" />Help</a>
                    </Nav>
                </Collapse>
            </Navbar>
        </div>
    );    
}

export default memo(Filters);